import { render, staticRenderFns } from "./PriceCategoryNav.vue?vue&type=template&id=7e5a0770&scoped=true&"
import script from "./PriceCategoryNav.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceCategoryNav.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceCategoryNav.vue?vue&type=style&index=0&id=7e5a0770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5a0770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e5a0770')) {
      api.createRecord('7e5a0770', component.options)
    } else {
      api.reload('7e5a0770', component.options)
    }
    module.hot.accept("./PriceCategoryNav.vue?vue&type=template&id=7e5a0770&scoped=true&", function () {
      api.rerender('7e5a0770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCategoryNav.vue"
export default component.exports